/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import logo from '../../../static/img/izi-logo-rounded-text-white.svg';
import logoDark from '../../../static/img/logo-iziwork.png';
import topBannerCloseIcon from '../../../static/img/top-banner-x-close.svg';
import './style.scss';

export default function Header(props) {
  const [open, setOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [topBanner, setTopBanner] = useState({
    show_top_banner: null,
    top_banner_background_color: null,
    top_banner_text_color: null,
    top_banner_message: null
  });

  useEffect(() => {
    const { lang } = props;
    const topBannerObj = props.topBanner.edges
      .filter((item) => item.node.polylang_current_lang === lang && item.node.acf !== null && item.node.acf.top_banner_message)
      .map((item) => {
        return item.node.acf;
      });
    setTopBanner(topBannerObj[0]);

    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop < 50 && scrolling === true) {
        setScrolling(false);
      } else if (scrollTop > 50 && scrolling !== true) {
        setScrolling(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
  }, [props, scrolling]);

  const handleToggleMenu = () => {
    const toggle = !open;
    setOpen(toggle);
  };

  const renderTopBanner = () => {
    const {
      show_top_banner = false,
      top_banner_background_color = '#ff2753',
      top_banner_text_color = '#fff',
      top_banner_message = ''
    } = topBanner;

    return (
      <div>
        {show_top_banner &&
          <div
            className={`top-banner ${
              show_top_banner === 'false' || sessionStorage.getItem('izi-top-banner') === 'hide' ? 'hide' : null
            }`}
            style={{ backgroundColor: top_banner_background_color, color: top_banner_text_color }}
          >
            <div
              className="top-banner__content"
              dangerouslySetInnerHTML={{
                __html: top_banner_message
              }}
            />
            <span
              className="top-banner__close"
              onClick={() => {
                sessionStorage.setItem('izi-top-banner', 'hide');
                setTopBanner({ show_top_banner: false });
              }}
            >
              <img src={topBannerCloseIcon} alt="close" />
            </span>
          </div>}
      </div>
    );
  };

  const { lang, menu } = props;
  const { show_top_banner = false } = topBanner;

  let className;
  let componentChunkName;
  let homepage;
  if (typeof window !== 'undefined') {
    componentChunkName = props.otherProps.pageResources.page.componentChunkName;
    if (componentChunkName === 'component---src-pages-blog-blog-js' ||
      componentChunkName === 'component---src-pages-download-app-download-app-js' ||
      componentChunkName === 'component---src-pages-press-landing-press-landing-js' ||
      componentChunkName === 'component---src-pages-blog-post-js' ||
      componentChunkName === 'component---src-pages-company-landing-company-js' ||
      componentChunkName === 'component---src-pages-gdpr-gdpr-js' ||
      componentChunkName === 'component---src-pages-static-page-static-page-js' ||
      componentChunkName === 'component---src-pages-partners-details-partners-details-js' ||
      componentChunkName === 'component---src-pages-about-about-js') {
      className = 'dark';
    }
    if (componentChunkName === 'component---src-pages-home-page-home-page-js') {
      homepage = 'homepage';
    }
  }

  return (
    <header
      id="iziwork-header"
      className={`header-land ${className} ${open ? 'open' : ''}
        ${scrolling ? 'header-bg' : ''}
        ${homepage ? 'homepage' : ''}
        ${show_top_banner === 'true' && sessionStorage.getItem('izi-top-banner') !== 'hide' ? 'with-top-banner' : ''}`}
    >
      {renderTopBanner()}
      <div className="container d-flex justify-content-start align-items-center">
        <div className="menu-overlay" />
        <Link className="logo" to={`/${lang}/`}>
          <img
            src={(className === 'dark' || scrolling || open || show_top_banner === 'true' && (sessionStorage.getItem('izi-top-banner')) !== 'hide') ? logoDark : logo}
            height="36"
            width="auto"
            alt="iziwork"
          />
        </Link>
        <div className="navigation d-flex ml-auto">
          <div
            className={`nav-toggle ${open}`}
            onClick={() => handleToggleMenu()}
          >
            <p>MENU</p>
            <div className="cross">
              <span />
              <span />
              <span />
            </div>
          </div>
          <nav className="nav" id="nav-header">
            <ul className="d-flex list-unstyled m-0 align-items-center">
              {componentChunkName === 'component---src-pages-worker-landing-worker-js' ?
                <li>
                  <a
                    className={`
                    izi-btn izi-btn-small izi-btn-line-white
                    ${scrolling ? 'izi-btn-Grey-300' : null}
                  `}
                    href="https://agence.iziwork.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {lang === 'fr' && "Besoin d'aide ?"}
                    {lang === 'it' && 'Ho bisogno di aiuto ?'}
                  </a>
                </li>
                : null }
              {menu.items.map((item) => <li key={item.title}>
                <Link
                  className={`
                    izi-btn izi-btn-small izi-btn-line-white
                    ${scrolling ? 'izi-btn-Grey-300' : null}
                    ${item.classes}
                  `}
                  to={item.url}
                >
                  {item.title}
                </Link>
              </li>
              )}
              {componentChunkName === 'component---src-pages-company-landing-company-js' ?
                <li>
                  <a
                    className={`
                    izi-btn izi-btn-small izi-btn-line-blue iziwork-pro
                    ${scrolling ? 'izi-btn-Grey-300' : null}
                  `}
                    href="https://pro.iziwork.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {lang === 'fr' && 'Mon compte'}
                    {lang === 'it' && 'Il mio account'}
                  </a>
                </li>
                : null }
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}
